module.exports = __webpack_public_path__ + "img/BusinessContact.de62f0b0.png";